import api from "../../api";
import UIStore from "../../store/uiStore";
import logger from "../../services/Logger";

export const getModeAuth = async () => {
  const { setOrgAvailable, setOrgModeError } = UIStore.getState();

  try {
    const response = await api({ method: "GET", url: "/user-context/org-mode" });
    const orgAvailable = response?.data?.data?.org_available;

    if (typeof orgAvailable !== "boolean") {
      throw new Error("org-mode response is missing org_available");
    }

    setOrgAvailable(orgAvailable);
    setOrgModeError(null);
  } catch (error) {
    // Leave orgAvailable unresolved: defaulting either way silently grants or hides admin UI.
    setOrgModeError(error.message);
    logger.error('getModeAuth', 'Error retrieving org mode', { error: error.message });
  }
};
